export default function redirectMomo(url, locale, isTestMode = false) {
    if (url.href) {
        const initialBaseUrlWithLocale = url.href.split('/').filter(Boolean);
        !url.href.includes('lang-') ? initialBaseUrlWithLocale.splice(4, 0, `lang-${locale}`) : void 0;
        let newUrlHref = initialBaseUrlWithLocale.join('/');

        const linkBaseURL = newUrlHref.split("captcha");
        const checkoutBaseURL = process.env.CHECKOUT_BASE_URL;
        let redirectURL = new URL(`captcha${linkBaseURL[1]}`, checkoutBaseURL)

        if (isTestMode === true && checkoutBaseURL === 'https://checkout.flutterwave.com') {
            redirectURL = new URL(`captcha${linkBaseURL[1]}`, url.origin);
        }

        // New href sample: "https://<env-base-url>/captcha/verify/lang-en/<sample-id>"
        url.href = redirectURL;
        return url;
    }
}